import React, { Fragment } from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

const ModalContent = props => {
    return (
        <Fragment>
            <ModalHeader toggle={() => props.onToggle()}>
                {props.headerText}
            </ModalHeader>
            <ModalBody>
                {props.bodyContent}
            </ModalBody>

            <ModalFooter>
                <Button
                    color='primary'
                    onClick={() => props.onConfirm()}>
                    <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;
                    {i18n.t('common:buttons.confirm')}
                </Button>{' '}
                <Button
                    color='outline-primary'
                    onClick={() => props.onCancel()}>
                    {i18n.t('common:buttons.cancel')}
                </Button>
            </ModalFooter>
        </Fragment>
    );
}

export default ModalContent;


// WEBPACK FOOTER //
// ./src/components/systemControl/database/common/ModalContent.js